/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash-es';
import { WithStyles } from '@material-ui/core';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
//use useParams
import { useLocation, useNavigate } from 'react-router-dom';
import { generateStyle } from '../../utils/styles';
import Style from './style';
//import { RootState } from '../../reducers';
import Login from '../../components/Login/lazy';
import { RootState } from '../../reducers';
import { Link, Typography } from '../../components';
import {
	NavigateCode,
	ResetForm,
	SetCaptchaToken,
	SetClientId,
	SetClientNonce,
	SetClientState,
	SetRedirectUrl
} from '../../redux/types';

interface Props extends WithStyles<typeof Style> {
	[name: string]: any;
}

const HomePage: React.FC<Props> = ({ classes }: Props) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { executeRecaptcha } = useGoogleReCaptcha();
	const { REACT_APP_CAPTACHA_KEY = '' } = process.env;
	const location = useLocation();
	const [newLocation, setnewLocation] = useState<string>('');
	const clientId = useSelector<RootState, string>((state) => state.home.clientId);
	const locationPath = useSelector<RootState, string>((state) => state.login.location);
	const nextView = useSelector<RootState, string>((state) => state.login.nextView);
	const currentNonce = useSelector<RootState, string>((state) => state.login.currentNonce);

	// '/login';

	useEffect(() => {
		if (nextView && executeRecaptcha) {
			const enterprise = get(window, 'grecaptcha.enterprise', {});
			// console.log('callingfgsdf 1', nextView, enterprise);
			enterprise.ready(async () => {
				const token = await enterprise.execute(REACT_APP_CAPTACHA_KEY, {
					action: nextView
				});
				dispatch(SetCaptchaToken.action(token));
				console.log('NextView2', nextView, token);
			});
		}
		// setTimeout(() => {
		// 	const enterprise = get(window, 'grecaptcha.enterprise', {});

		// 	if (nextView && enterprise) {
		// 		console.log('token 1', nextView, enterprise);
		// 		enterprise.ready(async () => {
		// 			console.log('token 2', nextView);
		// 			const token = await enterprise.execute(
		// 				'6LfXCTcqAAAAAOwjp6GE-fwzwyThUijCbE2ylVhL',
		// 				{
		// 					action: nextView
		// 				}
		// 			);
		// 			console.log('token 3', token);
		// 		});
		// 	}
		// }, 1000);

		// if (nextView && executeRecaptcha) {
		// 	//	setRefreshReCaptcha((r) => !r);
		// 	executeRecaptcha(nextView)
		// 		.then((values) => {
		// 			dispatch(SetCaptchaToken.action(values));
		// 			console.log('Sdfgvsdfgsdfgsdali', values);
		// 		})
		// 		.catch((reason) => {
		// 			console.log('Sdfgvsdfgsdfgsdali', 'error', reason);
		// 		});
		// }
	}, [nextView, executeRecaptcha]);

	useEffect(() => {
		if (location.pathname === '/login') {
			dispatch(ResetForm.action('LOGIN'));
		} else if (location.pathname === '/auth' && nextView === 'LOGIN') {
			dispatch(ResetForm.action('LOGIN'));
			navigate('/login', { replace: true });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.pathname]);
	useEffect(() => {
		if (location.pathname === '/auth' && nextView === 'LOGIN') {
			dispatch(ResetForm.action('LOGIN'));
			navigate('/login', { replace: true });
		}
		if (newLocation) {
			window.location.replace(newLocation);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [nextView]);

	useEffect(() => {
		if (clientId === '') {
			navigate('/error');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [clientId]);

	useEffect(() => {
		if (locationPath !== '') {
			//const path =locationPath.replace("https://localhost:3001","http://localhost:3000");
			dispatch(ResetForm.action(''));
			setnewLocation(locationPath);
			navigate(-1);
			//	window.location.replace(locationPath);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [locationPath]);

	useEffect(() => {
		if (nextView === 'CODE') {
			dispatch(NavigateCode.action({ nonce: currentNonce }));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [nextView]);

	return (
		<div className={classes.root}>
			<Login newLocation={newLocation} />
			{/* <Typography className={classes.footer}>
				Protected by reCAPTCHA and subject to the DMART’s{' '}
				<Link onClick={()=>navigate("/privacy-policy")} style={{ color: '#046D39', cursor: 'pointer' }}>Privacy Policy</Link> and{' '}
				<Link onClick={()=>navigate("/terms-of-service")} style={{ color: '#046D39', cursor: 'pointer' }}>Terms of Service</Link>.
			</Typography> */}
		</div>
	);
};

export default generateStyle(Style, 'HomePage')(HomePage);
